import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../styles/menu.scss";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useMenuContext } from "../../context/MenuContext"; // Importando o contexto



const Acesso = () => {
    const { menuPai, menuFilho, atualizarMenus } = useMenuContext();
    const [clientescamp, setClientesCamp] = useState([]); // Clientes com acesso
    const [usuarios, setUsuarios] = useState([]); // Lista de usuários
    const [clientesSemAcesso, setClientesSemAcesso] = useState([]);
    const [clientesComAcesso, setClientesComAcesso] = useState([]);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null); // Usuário selecionado
    const [clienteSemAcessoSelecionado, setClienteSemAcessoSelecionado] = useState([]);
    const [clienteComAcessoSelecionado, setClienteComAcessoSelecionado] = useState([]);
    const [empresaId] = useState(); // ID da empresa fixa por enquanto

    const [campanhasSemAcesso, setCampanhasSemAcesso] = useState([]);
    const [campanhasComAcesso, setCampanhasComAcesso] = useState([]);
    const [campanhaSemAcessoSelecionada, setCampanhaSemAcessoSelecionada] = useState([]);
    const [campanhaComAcessoSelecionada, setCampanhaComAcessoSelecionada] = useState([]);
    const [clienteSelecionado, setClienteSelecionado] = useState(null); // Cliente selecionado

    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    // Carregar lista de usuários
    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL; // Definir aqui
        const fetchUsuarios = async () => {
            try {
                const token = localStorage.getItem("authToken");
                if (!token) throw new Error("Usuário não autenticado.");

                const response = await axios.get(`${API_URL}/api/menu/usuarios`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                const usuariosNormalizados = (response.data || []).map((user) => ({
                    ...user,
                    NOME_COMPLETO:
                        user.NOME_COMPLETO ||
                        `${user.NOME || ""} ${user.SOBRENOME || ""}`.trim(),
                }));

                setUsuarios(usuariosNormalizados);
                

            } catch (error) {
                console.error("Erro ao buscar usuários:", error.response?.data || error.message);
                if (error.response?.status === 401) navigate("/login");
                else toast.error("Erro ao carregar usuários.");
            }
        };

        fetchUsuarios();
    }, [navigate]

);

    // Carregar listas de clientes ao trocar o usuário selecionado
    useEffect(() => {
        if (!usuarioSelecionado) {
            setClientesComAcesso([]);
            setClientesSemAcesso([]);
            return;
        }
        const API_URL = process.env.REACT_APP_API_URL; // Definir aqui
        const token = localStorage.getItem("authToken");
        axios
            .get(`${API_URL}/api/menu/acesso/clientes?usuario=${usuarioSelecionado}&empresa=${empresaId}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setClientesComAcesso(res.data.clientesComAcesso || []);
                setClientesSemAcesso(res.data.clientesSemAcesso || []);
            })
            
            .catch((err) => {
                toast.error("Erro ao carregar clientes: " + (err.response?.data?.message || err.message));
            });
    }, [usuarioSelecionado, empresaId]);
    
    // Carregar campanhas ao selecionar um cliente
    const handleClienteChange = (e) => {
        const clienteId = Number(e.target.value);
        setClienteSelecionado(clienteId);

        setCampanhasComAcesso([]);
        setCampanhasSemAcesso([]);
        setCampanhaComAcessoSelecionada([]);
        setCampanhaSemAcessoSelecionada([]);

        if (!clienteId) return;

        const token = localStorage.getItem("authToken");
        axios
            .get(`${API_URL}/api/menu/acesso/campanhas?cliente=${clienteId}&usuario=${usuarioSelecionado}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                console.log("Dados recebidos do backend:", res.data);
                setCampanhasComAcesso(res.data.campanhaComAcesso || []);
                setCampanhasSemAcesso(res.data.campanhaSemAcesso || []);
                console.log("Campanhas com acesso:", res.data.campanhaComAcesso || []);
                console.log("Campanhas sem acesso:", res.data.campanhaSemAcesso || []);
                console.log("usuario selecionado: ",usuarioSelecionado)
            })
            .catch((err) => {
                toast.error("Erro ao carregar campanhas: " + (err.response?.data?.message || err.message));
            });
    };

    // Mover cliente para lista de acesso
    const adicionarAcesso = () => {
        if (clienteSemAcessoSelecionado.length === 0) return;

        clienteSemAcessoSelecionado.forEach((clienteId) => {
            axios
                .post(
                    `${API_URL}/api/menu/acesso/clientes/adicionar`,
                    {
                        usuarioId: usuarioSelecionado,
                        clienteId: clienteId,
                        adicionar: true,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        },
                    }
                )
                .then(() => {
                    const cliente = clientesSemAcesso.find((c) => c.ID_CLIENTE === clienteId);
                    setClientesComAcesso((prev) => [...prev, cliente]);
                    setClientesSemAcesso((prev) => prev.filter((c) => c.ID_CLIENTE !== clienteId));

                    // Atualiza o menu no contexto
                    const novosMenuPai = [...menuPai, cliente];
                    atualizarMenus(novosMenuPai, menuFilho); // Atualiza o menu no contexto
                })
                .catch((err) => toast.error("Erro ao adicionar acesso: " + err.message));
        });

        setClienteSemAcessoSelecionado([]); // Limpar seleção
    };

    // Remover cliente da lista de acesso
    const removerAcesso = () => {
        if (clienteComAcessoSelecionado.length === 0) return;

        clienteComAcessoSelecionado.forEach((clienteId) => {
            axios
                .post(
                    `${API_URL}/api/menu/acesso/clientes/remover`,
                    {
                        usuarioId: usuarioSelecionado,
                        clienteId: clienteId,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        },
                    }
                )
                .then(() => {
                    const cliente = clientesComAcesso.find((c) => c.ID_CLIENTE === clienteId);
                    setClientesSemAcesso((prev) => [...prev, cliente]);
                    setClientesComAcesso((prev) => prev.filter((c) => c.ID_CLIENTE !== clienteId));

                    // Atualiza o menu no contexto
                    const novosMenuPai = menuPai.filter((c) => c.ID_CLIENTE !== clienteId);
                    atualizarMenus(novosMenuPai, menuFilho); // Atualiza o menu no contexto
                })
                .catch((err) => toast.error("Erro ao remover acesso: " + err.message));
        });

        setClienteComAcessoSelecionado([]); // Limpar seleção
    };

    // Buscar clientes para alimentar as campanhas
    useEffect(() => {
        const token = localStorage.getItem("authToken");
        setCampanhasComAcesso([]);
        setCampanhasSemAcesso([]);
        setCampanhaComAcessoSelecionada([]);
        setCampanhaSemAcessoSelecionada([]);
        localStorage.removeItem("campanhaComAcesso");
        localStorage.removeItem("campanhaSemAcesso");
    
        const API_URL = process.env.REACT_APP_API_URL; // Definir aqui
        if (usuarioSelecionado) {
            axios
                .get(`${API_URL}/api/menu/acesso/clientes?usuario=${usuarioSelecionado}&empresa=${empresaId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((res) => {
                    setClientesCamp(res.data.clientesComAcesso || []);
                })
                .catch((err) => {
                    toast.error("Erro ao carregar clientes: " + (err.response?.data?.message || err.message));
                });
        }
    }, [usuarioSelecionado, empresaId]);

   

    // Adicionar acesso à campanha
    const adicionarAcessoCampanha = () => {
        if (campanhaSemAcessoSelecionada.length === 0) {
            toast.error("Selecione ao menos uma campanha para adicionar acesso.");
            return;
        }
    
        campanhaSemAcessoSelecionada.forEach((campanhaId) => {
            axios
                .post(
                    `${API_URL}/api/menu/acesso/campanhas/adicionar`,
                    {
                        usuarioId: usuarioSelecionado,
                        campanhaId: campanhaId,
                        adicionarcamp: true, // Nome correto do campo
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        },
                    }
                )
                .then(() => {
                    const campanha = campanhasSemAcesso.find((c) => c.ID_CAMPANHA === campanhaId);
                    setCampanhasComAcesso((prev) => [...prev, campanha]);
                    setCampanhasSemAcesso((prev) => prev.filter((c) => c.ID_CAMPANHA !== campanhaId));
                    toast.success("Acesso adicionado com sucesso!");
                })
                .catch((err) => {
                    toast.error("Erro ao adicionar acesso: " + (err.response?.data?.message || err.message));
                });
        });
    
        setCampanhaSemAcessoSelecionada([]); // Limpar seleção
    };
    
    // Remover acesso de campanha
    const removerAcessoCampanha = () => {
        if (!clienteSelecionado) {
            toast.error("Selecione um cliente antes de remover acesso.");
            return;
        }

        campanhaComAcessoSelecionada.forEach((campanhaId) => {
            axios
                .post(
                    `${API_URL}/api/menu/acesso/campanhas/remover`,
                    { usuarioId: usuarioSelecionado, campanhaId },
                    { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
                )
                .then(() => {
                    const campanha = campanhasComAcesso.find((c) => c.ID_CAMPANHA === campanhaId);
                    setCampanhasSemAcesso((prev) => [...prev, campanha]);
                    setCampanhasComAcesso((prev) => prev.filter((c) => c.ID_CAMPANHA !== campanhaId));
                })
                .catch((err) => toast.error("Erro ao remover acesso: " + err.message));
        });
        setCampanhaComAcessoSelecionada([]); // Limpar seleção
    };

    return (
        <div className="acesso-container">
            <h1>Controle de Acesso</h1>
            <div className="acesso-top">
                <label htmlFor="usuario">Usuário:</label>
                <select
                    value={usuarioSelecionado || ""}
                    onChange={(e) => setUsuarioSelecionado(Number(e.target.value))}
                >
                    <option value="">Selecione um usuário</option>
                    {Array.isArray(usuarios) &&
                        usuarios.map((user) => (
                            <option key={user.ID_USERS} value={user.ID_USERS}>
                                {user.NOME_COMPLETO || user.NOME}
                            </option>
                        ))}
                </select>
            </div>
            <div className="acesso-body">
                <div className="acesso-list">
                    <h2>Sem Acesso</h2>
                    <select
                        multiple
                        className="cliente-list"
                        value={clienteSemAcessoSelecionado}
                        onChange={(e) =>
                            setClienteSemAcessoSelecionado(
                                Array.from(e.target.selectedOptions, (option) => Number(option.value))
                            )
                        }
                    >
                        {Array.isArray(clientesSemAcesso) && clientesSemAcesso.map((cliente) => (
                            <option key={cliente.ID_CLIENTE} value={cliente.ID_CLIENTE}>
                                {cliente.NOME_CLIENTE}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="acesso-actions">
                    <button onClick={adicionarAcesso}>➤</button>
                    <button onClick={removerAcesso}>⮜</button>
                </div>
                <div className="acesso-list">
                    <h2>Com Acesso</h2>
                    <select
                        multiple
                        className="cliente-access-list"
                        value={clienteComAcessoSelecionado}
                        onChange={(e) =>
                            setClienteComAcessoSelecionado(
                                Array.from(e.target.selectedOptions, (option) => Number(option.value))
                            )
                        }
                    >
                        {Array.isArray(clientesComAcesso) && clientesComAcesso.map((cliente) => (
                            <option key={cliente.ID_CLIENTE} value={cliente.ID_CLIENTE}>
                                {cliente.NOME_CLIENTE}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            {/* Controle de acesso campanhas */}
            <br />
            <h3>Acesso campanhas</h3>
            <br />
            <div className="acesso-top">
                <select value={clienteSelecionado || ""} onChange={handleClienteChange}>
                    <option value="">Selecione um Cliente</option>
                    {Array.isArray(clientescamp) && clientescamp.map((cliente) => (
                        <option key={cliente.ID_CLIENTE} value={cliente.ID_CLIENTE}>
                            {cliente.NOME_CLIENTE}
                        </option>
                    ))}
                </select>
            </div>
            <div className="acesso-body">
                <div className="acesso-list">
                    <h2>Sem Acesso</h2>
                    <select
                        multiple
                        className="cliente-list"
                        value={campanhaSemAcessoSelecionada}
                        onChange={(e) =>
                            setCampanhaSemAcessoSelecionada(
                                Array.from(e.target.selectedOptions, (option) => Number(option.value))
                            )
                        }
                    >
                        {Array.isArray(campanhasSemAcesso) && campanhasSemAcesso.map((campanha) => (
                            <option key={campanha.ID_CAMPANHA} value={campanha.ID_CAMPANHA}>
                                {campanha.NOME_CAMPANHA}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="acesso-actions">
                    <button onClick={adicionarAcessoCampanha}>➤</button>
                    <button onClick={removerAcessoCampanha}>⮜</button>
                </div>
                <div className="acesso-list">
                    <h2>Com Acesso</h2>
                    <select
                        multiple
                        className="cliente-access-list"
                        value={campanhaComAcessoSelecionada}
                        onChange={(e) =>
                            setCampanhaComAcessoSelecionada(
                                Array.from(e.target.selectedOptions, (option) => Number(option.value))
                            )
                        }
                    >
                        {Array.isArray(campanhasComAcesso) && campanhasComAcesso.map((campanha) => (
                            <option key={campanha.ID_CAMPANHA} value={campanha.ID_CAMPANHA}>
                                {campanha.NOME_CAMPANHA}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
};

export default Acesso;
